import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { deleteUsers } from "services/UserService";
import { getUsers } from "services/UserService";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useAuth } from "hooks/useAuth";


const UsersList = () => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [deleteUserId, setDeleteUserId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const navigate = useNavigate();
  const { hasPermission } = useAuth();


  useEffect(() => {
    getUsersList();
  }, []);

  useEffect(() => {
    handleSearch();
  }, [searchQuery, users]);

  const getUsersList = () => {
    getUsers().then((response) => {
      if (response && response.data.success) {
        setUsers(response.data.users);
        setFilteredUsers(response.data.users);
      }
    });
  };

  const handleSearch = () => {
    const query = searchQuery.toLowerCase();
    const filtered = users.filter(
      (user) =>
        user.first_name?.toLowerCase().includes(query) ||
        user.email?.toLowerCase().includes(query) ||
        user.phone?.toLowerCase().includes(query)
    );
    setFilteredUsers(filtered);
    setPage(0);
  };

  const handleChangePage = (newPage) => setPage(newPage);
  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const paginatedUsers = filteredUsers.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleCreate = () => {
    navigate("/add-user", { state: { isEdit: false } });
  };

  const handleEdit = (user) => {
    navigate("/add-user", { state: { isEdit: true, editFormData: user } });
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this coupon?")) {
      //dispatch(deleteCouponAction(id));
    }
  };

  const exportToCSV = () => {
    const csvData = filteredUsers.map((user) => ({
      "Employee Code": user.employeeCode,
      "Employee Name": user.name,
      "Phone No": user.phone,
      "Email": user.email,
      "Status": user.status,
    }));
  
    const worksheet = XLSX.utils.json_to_sheet(csvData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Users");
  
    const csvOutput = XLSX.write(workbook, {
      bookType: "csv",
      type: "array",
    });
  
    const blob = new Blob([csvOutput], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "users_list.csv");
  };
  
  const exportToXLS = () => {
    const xlsData = filteredUsers.map((user) => ({
      "Employee Code": user.emp_code,
      "Employee Name": user.first_name,
      "Phone No": user.phone,
      "Email": user.email,
      "Status": user.status,
    }));  
    const worksheet = XLSX.utils.json_to_sheet(xlsData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Users");
  
    const xlsOutput = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
  
    const blob = new Blob([xlsOutput], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
  
    saveAs(blob, "users_list.xlsx");
  };

  const deleteUser = (id) => {
    setDeleteUserId(id);
    setShowDeleteModal(true);
  };
  const confirmDeleteUser = () => {

    deleteUsers(deleteUserId).then((response) => {
      if (response && response.data.success) {
        setShowDeleteModal(false);
        getUsersList();
      }
    });
    //setDeleteUserId(deleteUserId);
  };


  return (
    <>
      <section className="content-header">
        <div className="header-icon">
          <i className="fa fa-users"></i>
        </div>
        <div className="header-title">
          <h1>Manage Users</h1>
          <small>Users List</small>
        </div>
      </section>

      <section className="content">
        <div className="row">
          <div className="col-lg-12">
            <div className="buttonexport" id="buttonlist">
            {hasPermission("Add Users") && (
              <Link className="btn btn-add" to="/add-user">
                <i className="fa fa-plus"></i> Add Users
              </Link>
            )}
            </div>
            <div className="card lobicard mt-2">
              <div className="card-header">
                <div className="card-title custom_title">
                  <h4>Users List</h4>
                </div>
              </div>
              <div className="card-body">
                <div className="d-flex align-items-center mb-3">
                  <select
                    value={rowsPerPage}
                    onChange={handleRowsPerPageChange}
                    className="form-control w-auto mr-3"
                  >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>

                  <input
                    type="text"
                    placeholder="Search by name, email, or phone"
                    className="form-control w-25 mr-3"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <div className="btn-group ml-3">
                    <button
                      className="btn btn-exp btn-sm "
                      data-toggle="dropdown"
                    >
                      <i className="fa fa-bars"></i> Export Table Data
                    </button>
                    <ul className="dropdown-menu exp-drop" role="menu">
                      <li>
                        <a
                          href="#"
                          onClick={exportToCSV}
                        >
                          <img
                            src="assets/dist/img/csv.png"
                            width="24"
                            alt="logo"
                          />{" "}
                          CSV
                        </a>
                      </li>

                      <li class="dropdown-divider"></li>
                      <li>
                        <a
                          href="#"
                          onClick={exportToXLS}
                        >
                          <img
                            src="assets/dist/img/xls.png"
                            width="24"
                            alt="logo"
                          />{" "}
                          XLS
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>Employee Code</th>
                        <th>Employee Name</th>
                        <th>Phone No</th>
                        <th>Email</th>
                        <th>Password</th>
                        {/* <th>Status</th>*/}
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedUsers.length > 0 ? (
                        paginatedUsers.map((user) => (
                          <tr key={user.id}>
                            <td>{user.emp_code}</td>
                            <td>{user.first_name}</td>
                            <td>{user.phone}</td>
                            <td>{user.email}</td>
                            <td>********</td>
                            {/*<td>
                              <span className="label label-success">
                                {user.status}
                              </span>
                            </td>*/}
                            <td>
                            {hasPermission("Edit Users") && (
                              <button
                                type="button"
                                className="btn btn-add btn-sm mr-3"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleEdit(user);
                                }}
                              >
                                <i className="fa fa-pencil"></i>
                              </button>
                              )}
                               {hasPermission("Delete Users") && (
                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  deleteUser(user.id);
                                }}
                                data-toggle="modal"
                                data-target="#customer2"
                              >
                                <i className="fa fa-trash-o"></i>
                              </button>
                               )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No users found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Pagination Controls */}
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <span>
                    Showing {page * rowsPerPage + 1} to{" "}
                    {Math.min((page + 1) * rowsPerPage, filteredUsers.length)}{" "}
                    of {filteredUsers.length} entries
                  </span>
                  <div>
                    <button
                      className="btn btn-default btn-sm mr-2"
                      onClick={() => handleChangePage(Math.max(0, page - 1))}
                      disabled={page === 0}
                    >
                      Prev
                    </button>
                    <button
                      className="btn btn-default btn-sm"
                      onClick={() =>
                        handleChangePage(
                          Math.min(
                            Math.floor(filteredUsers.length / rowsPerPage),
                            page + 1
                          )
                        )
                      }
                      disabled={
                        (page + 1) * rowsPerPage >= filteredUsers.length
                      }
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {showDeleteModal && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div
            className="modal-dialog modal-lg"
            role="document"
            style={{ zIndex: "9999" }}
          >
            <div className="modal-content">
              <div className="modal-header modal-header-primary">
                <h3>
                  <i className="fa fa-user m-r-5"></i> Delete Users
                </h3>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                  onClick={(e) => {
                    setShowDeleteModal(false);
                  }}
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <form className="form-horizontal">
                      <div className="row">
                        <div className="col-md-12 form-group user-form-group">
                          <label className="control-label">Delete Users</label>
                          <div className="float-right">
                            <button
                              type="button"
                              className="btn btn-danger btn-sm mr-3"
                              onClick={(e) => {
                                e.stopPropagation();
                                setShowDeleteModal(false);
                              }}
                            >
                              NO
                            </button>
                            <button
                              type="button"
                              className="btn btn-add btn-sm"
                              onClick={(e) => {
                                e.stopPropagation();
                                confirmDeleteUser();
                              }}
                            >
                              YES
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger float-left"
                  data-dismiss="modal"
                  onClick={(e) => {
                    setShowDeleteModal(false);
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UsersList;
